<!-- dpac-approfondimento: tutto il contenuto è fornito da questo componente padre -->
<dpac-approfondimento
  [heroTitleLine1]="heroTitleLine1"
  [heroHighlight]="heroHighlight"
  [heroTitleSuffix]="heroTitleSuffix"
  [heroSubtitle]="heroSubtitle"
  [heroNote]="heroNote"
  [heroCtas]="heroCtas"
  [vantaggiTitle]="vantaggiTitle"
  [vantaggiTitleSuffix]="vantaggiTitleSuffix"
  [vantaggi]="vantaggi"
  [tabs]="tabs"
  [contribuisciTitle]="contribuisciTitle"
  [contribuisciDescription]="contribuisciDescription"
  [contribuisciCta]="contribuisciCta()"
  [stepsTitle]="stepsTitle"
  [steps]="steps"
  [icon]="icon()"
  [creditiText]="creditiText"
  [creditiIcon]="creditiIcon"
  [navbarOffset]="'124px'"
  [showBackToTop]="true"
  (ctaClick)="onCtaClick($event)"
  (emitModal)="showModal()"
/>
